import React from 'react';

const SvgIcAccounts = (props) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg" width="16.056" height="16.056" viewBox="0 0 16.056 16.056">
  <path id="Accounts_SVG" data-name="Accounts SVG" d="M3.806,11.632H8.524a2.2,2.2,0,0,0-.5,1.229l-.007.176V16.65a2.2,2.2,0,0,0,.5,1.405h-.1c-2.747,0-4.773-.861-6.011-2.6A2.208,2.208,0,0,1,2,14.176v-.739A1.806,1.806,0,0,1,3.806,11.632Zm8.429-2.007h2.409a1,1,0,0,1,1,.9l.005.1v1h1a1.405,1.405,0,0,1,1.405,1.405V16.65a1.405,1.405,0,0,1-1.405,1.405H10.227A1.405,1.405,0,0,1,8.822,16.65V13.037a1.405,1.405,0,0,1,1.405-1.405h1v-1a1,1,0,0,1,.9-1l.1-.005h0Zm2.208,1.2H12.436v.8h2.007ZM8.421,2A4.015,4.015,0,1,1,4.406,6.015,4.015,4.015,0,0,1,8.421,2Z" transform="translate(-2 -2)" fill="currentColor"/>
</svg>
);

export default SvgIcAccounts;
